import React, { forwardRef, useMemo } from 'react';
import { useSelector } from 'react-redux';

import { DoubleRightOutlined } from '@ant-design/icons';
import ButtonSmallIcon from 'common/components/button/ButtonSmallIcon';
import gridSelector from 'common/components/grid-view/controllers/selectors';
import selectorUser from '@redux/user/selectors';

import { checkIsSuperAdmin } from 'utils';

const MoveProductsToMember = (props, ref) => {
  const { disabled } = props;

  const selectedItemDetailList = useSelector(
    gridSelector.makeSelectDetailCurrentITemsSelection()
  );
  const userInfo = useSelector(selectorUser.makeSelectUserInfo());

  const isSuperAdmin = checkIsSuperAdmin(userInfo?.roles);

  const openModalMoveAssetToMember = () => {
    ref.current.openModal();
  };

  const isAllowToMoveProduct = useMemo(() => {
    if (!selectedItemDetailList?.length) {
      return false;
    }

    if (userInfo?.isSuperMember || isSuperAdmin) {
      return true;
    } else {
      return false;
    }
  }, [selectedItemDetailList, userInfo, isSuperAdmin]);

  return (
    <>
      <ButtonSmallIcon
        className='button-item-dropdown'
        icon={<DoubleRightOutlined />}
        textDisplay='Move Products to Member'
        onClick={openModalMoveAssetToMember}
        disabled={!isAllowToMoveProduct || disabled}
      />
    </>
  );
};

MoveProductsToMember.propTypes = {};

export default forwardRef(MoveProductsToMember);
